import React, { useState, useContext, useEffect, } from 'react'
import { OnTheMenuDataContext } from '../../../context-api/OnTheMenuDataProvider';
import Storetitle from '../../../composed/storetitle/storetitle';
import { isMobile, isDesktop, isIpad } from '../../../global/ScreenSizeHelper';
import TextTransformation from '../../../global/textTransformation';
import './RestaurantMenu.scss'
import MenuTabs from '../../../atomic/MenuTabs/MenuTabs';
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from "../../../global/getUrl";
import { LoginDataContext } from '../../../context-api/LoginDataProvider';
import ProductCard from '../../../composed/ProductCard/ProductCard';
import PromotionalKitchenMenu from '../../../composed/promotionalKitchenMenu/PromotionalKitchenMenu';
import ProductVerticalStepper from './VerticalProductSteppers';

const RestaurantMenuMobile = () => {
    const {
        productsData = {},
        sortedKitchenData,
        cartItems, ShowPromotionalKitchen, getMealOffering } = useContext(OnTheMenuDataContext)
    const { loginData, onLogin, isLoggedIn, onCustomerInformationApiHandler, customerInfoData, ButtonSwitchSubscription } = useContext(LoginDataContext)
    const { loading, data, success, errorMessage } = customerInfoData
    const custInfoData = data?.data || []
    const { status, freePayAsYouGoDelivery,
        regularMenuAvailable, subscriptionMenuAvailable, freeSubscriptionDelivery, deliverySubscription_fee, deliveryPayAsYouGo_fee } = sortedKitchenData

    const IsCartItems = Array.isArray(cartItems) && cartItems.length > 0
    const [mealType, setMealType] = useState('Menu');

    const mealTypeButtons = [];
    if (regularMenuAvailable) {
        mealTypeButtons.push({ label: 'Regular Menu', value: 'Menu' });
    }
    if (subscriptionMenuAvailable) {
        mealTypeButtons.push({ label: 'Combo Menu', value: 'Combo Menu' });
    }

    const { storename: urlStoreName } = getUrlParams();
    const [menuTabNames, setMenuTabNames] = useState({ 'Menu': [], 'Combo Menu': [] })
    const [activeTab, setActiveTab] = useState('')
    const [positionFixed, setPositionFixed] = useState(false)
    const [noProducts, setNoProducts] = useState(true)
    const handleMealType = (x) => {
        setMealType(x.value)
        setActiveTab(menuTabNames[x.value]?.[0] || '')
        scrollToTop()

    }
    const Mapping = { Menu: 'NonMealItems', 'Combo Menu': 'MealItems' }
    const ProductListObject = productsData?.data?.categorizedProducts?.[urlStoreName]?.[Mapping[mealType]]
    const custActStatus = (custInfoData?.user_Info?.reason_status === 'Active' || custInfoData?.user_Info?.reason_status === 'Customer unsubscribed');
    const custMealPlan = custInfoData?.meal_Package?.meal_plan;
    const custActType = custInfoData?.user_Info?.account_type === 'Subscription';
    const custErrorUser = errorMessage === 'User does not exist' // Logot User and ask to login again 
    const custAdminInactive = errorMessage === 'Account is blocked by Administration'
    const zeroPlatesAvailable = custInfoData?.available_plates === 0; // Chck with kuldeep
    const disableProductView = !isLoggedIn || !custActType || zeroPlatesAvailable;



    useEffect(() => {
        if (productsData.data && urlStoreName) {
            if (productsData?.data?.categorizedProducts && productsData?.data?.categorizedProducts?.[urlStoreName]) {


                setMenuTabNames({
                    ...menuTabNames,
                    "Menu": Object.keys(productsData?.data?.categorizedProducts?.[urlStoreName]?.NonMealItems || {}) || [],
                    "Combo Menu": Object.keys(productsData?.data?.categorizedProducts?.[urlStoreName]?.MealItems || {}).filter((key) => {
                        const allowedProducts = getMealOffering()[key];
                        if (!allowedProducts) {
                            return false;
                        }
                        return true;
                    }) || [],
                })

                setActiveTab((Object.keys(productsData?.data?.categorizedProducts?.[urlStoreName]?.NonMealItems || {}) || [])[0] || '')

            }
        }
    }, [productsData])



    // console.log('--------window.pageYOffset mobile', window.pageYOffset)

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleFlag = () => {
        if (window.pageYOffset >= 122) {
            setPositionFixed(true)
        } else {
            setPositionFixed(false)
        }
    }

    useEffect(() => {

        window.addEventListener('scroll', handleFlag);
        scrollToTop();

        return () => {
            window.removeEventListener('scroll', handleFlag);
        }

    }, [])


    return (
        <div className='store-menu-mobile-container'>
            <div className='section-1'>
                <Storetitle mealType={mealType} />
                <div style={{
                    display: 'flex',
                    // padding: '10px 5px 10px 10px',
                    flexDirection: 'column',
                    width: '100%',
                    backgroundColor: '#ffff',
                    zIndex: '10010',
                    boxShadow: positionFixed ? '0 3px 3px -1px rgba(0,0,0,.2)' : 'none',
                    borderBottom: positionFixed ? '' : '2px solid #f1f1f1',
                    position: positionFixed ? 'fixed' : 'inherit',
                    top: 0,
                    //transition: 'position 5s'
                }}>
                    <div style={{
                        display: 'flex',
                        backgroundColor: '#FCFCFC',
                        borderRadius: '7px', border: '1px solid #E3E3E3',
                        height: '65px', margin: '5px 5px 0px 5px',
                        alignItems: 'center',
                    }}>
                        {
                            mealTypeButtons.map((el, index) => {
                                return <button key={index} className={`button-mobile ${mealType === el.value ? "active-button-mobile" : "inactive-button-mobile"}`}
                                    onClick={() => { handleMealType(el) }}>
                                    <div className="meal-type-button-content">
                                        <div className="meal-type-button-label">{el.label}</div>

                                        {(deliveryPayAsYouGo_fee > 0 || deliverySubscription_fee > 0) &&
                                            <div className="meal-type-button-subcontent">
                                                {mealType === 'Menu' && el.value === 'Menu' && `$${deliveryPayAsYouGo_fee} Delivery In 20-40 min`}
                                                {(mealType === 'Combo Menu' && el.value === 'Combo Menu' && freeSubscriptionDelivery) &&
                                                    <div style={{ letterSpacing: '0.5px' }}> Free NextDay {`| $${deliverySubscription_fee} Delivery Now`}</div>

                                                }
                                            </div>
                                        }
                                    </div>
                                </button>
                            })
                        }
                    </div>

                    <div style={{ margin: '0px 5px 0px 10px' }}>
                        {menuTabNames[mealType]?.length > 0 &&
                            <MenuTabs tabNames={menuTabNames[mealType]}
                                value={activeTab}
                                setValue={setActiveTab}
                                mobilePositionFixed={positionFixed} />}

                    </div>
                </div>

                {ShowPromotionalKitchen() && <PromotionalKitchenMenu />}

                <div className="product-mobile-container">
                    {/*{mealType === 'Combo Menu' && disableProductView && <div style={{
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        // background: 'rgb(0,0,0,0.2)',
                        background: 'rgba(0, 0, 0, 0.3)',
                        // opacity: '0.8',
                        // border: '1px solid #181436',
                        borderRadius: '3px',
                        display: 'flex',
                        // justifyContent: 'center', 
                        // alignItems: 'top'
                        zIndex: 6,
                        top: 0
                    }}>
                        <div className='product-login-popup-mobile'>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <div>
                                    <InsertEmoticonIcon sx={{ color: '#181436', fontSize: '40px' }} />
                                </div>
                                <div style={{
                                    fontFamily: 'Roboto Medium',
                                    fontSize: '14px', margin: '0px 0px 0px 5px', transform: 'translateZ(45px)'
                                }}>
                                    {ButtonSwitchSubscription()?.verbiage}
                                </div>
                            </div>

                            <AtomicButton
                                label={ButtonSwitchSubscription()?.buttonLabel}
                                loading={false}
                                style={{ height: '30px', width: '80%' }}
                                handleSubmit={ButtonSwitchSubscription()?.handleMethod}
                            />
                        </div>

                    </div>}*/}
                    {mealType === 'Menu' && Object.keys(ProductListObject || {}).map((el) => {

                        return (
                            <div className='product-card-list' id={el} key={el}>
                                {/* <div style={{
                                    color: 'black',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    margin: '10px',
                                    paddingLeft: '5px',
                                    textTransform: 'capitalize',
                                }}>{TextTransformation(el)}</div> */}
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {ProductListObject[el] &&
                                        ProductListObject[el].map(product => {
                                            const ProdCardWidth = () => ['starters_and_sides', 'desserts_and_drinks', 'kids', 'kids_menu', 'party_pack', 'side', 'complementry', 'promotional'].includes(product?.product_category);
                                            return <div style={{
                                                width: ProdCardWidth() ? '50%' : '100%',
                                                height: ProdCardWidth() ? 'auto' : '410px'
                                            }} key={product.product_name}>
                                                <ProductCard product={product} mealType={mealType}></ProductCard>
                                            </div>
                                        }
                                        )
                                    }
                                </div>
                            </div>

                        )
                    })
                    }

                    {mealType === 'Combo Menu' &&
                        <ProductVerticalStepper
                            ProductListObject={ProductListObject}
                            mealType={mealType}
                        />}
                </div>

            </div>
            <div className='section-2'>
                {/** This section WAS for mobile cart footer but we imported mobilecart component in store footer */}

            </div>

        </div>
    )
}

export default RestaurantMenuMobile